import { APPLICANT_ASSESSMENT_RESULT } from '../applicants/applicantTypes';
import type { DeliberationStageScore } from './deliberationTypes';

/** A stage's outcome as a one-character code, with its word for a screen reader. */
export interface StageOutcome {
  code: string;
  label: string;
}

/**
 * The stage's outcome as Deliberate writes it — `P` Passed, `F` Failed, `-` not recorded yet (product
 * call, 20 Oct 2026). ONE mapping, read by the applicant rail, the applicants table and Applicants' own
 * Assessments tab (21 Oct 2026) alike, so the three
 * cannot disagree. A hidden stage has none: its result never reached this reader.
 */
export function stageOutcome(
  stage: Pick<DeliberationStageScore, 'isHidden' | 'result'> | null | undefined,
): StageOutcome | undefined {
  if (!stage || stage.isHidden) return undefined;
  if (stage.result === APPLICANT_ASSESSMENT_RESULT.Passed) return { code: 'P', label: 'Passed' };
  if (stage.result === APPLICANT_ASSESSMENT_RESULT.Failed) return { code: 'F', label: 'Failed' };

  return { code: '-', label: 'Not recorded yet' };
}
